module.exports = __webpack_public_path__ + "70c6b8ddd2734bb14a2ef5170bd3ac8a.png";